module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Bottle1-15f6c93f959e92b06bb108ea39a39437.svg";